import { useRef, useEffect, useCallback } from "react"

/**
 * Taken from https://github.com/webNeat/react-tidy/blob/master/src/useIsMounted/useIsMounted.ts
 * usage example
 * const isMounted = useIsMounted()
 * if (isMounted()) {...}
 */
export function useIsMounted() {
  const isMounted = useRef(false)

  useEffect(() => {
    isMounted.current = true

    return () => {
      isMounted.current = false
    }
  }, [])

  return useCallback(() => isMounted.current, [])
}
